import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import IntelliSortTableContainer from 'common/containers/intellisort/IntelliSortTableContainer';
import theme from './IntelliSortContainer.scss';
import { withRouter } from 'common/components/core/router';

class IntelliSortContainer extends PureComponent {
    render() {
        return (
            <div className={theme.wrapper}>
                <IntelliSortTableContainer />
            </div>
        );
    }
}

export default withRouter(connect()(IntelliSortContainer));
